function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'lodash/isEmpty';
import analyticsMetric from '@domain-group/fe-allhomes-library/lib/enums/analytics-metric';
import { ah, ga, mixpanel } from '@domain-group/fe-co-allhomes-analytics';
import { GAActions, GALabels, MixpanelLabels, PageSection } from './constants';
import * as ga4 from './ga4-handlers';
var SearchTypeMap = {
  SCHOOL: GALabels.SCHOOL_SEARCH,
  DEVELOPMENT: GALabels.PROJECT_SEARCH,
  ADDRESS: GALabels.ADDRESS_SEARCH
};
export default {
  '/autocomplete-item-select/': (_key, _ref) => {
    var item = _ref.item;
    var label = SearchTypeMap[item === null || item === void 0 ? void 0 : item.type];
    return label ? ga.typeahead(GAActions.SEARCH_PAGE, label) : null;
  },
  'view-search-result-page': () => mixpanel.viewSearchResult(),
  'listing-click': (_key, data) => {
    var _data$listing$badges, _data$listing$inclusi;
    return _objectSpread(_objectSpread({}, mixpanel.clickListingCard(_objectSpread(_objectSpread({
      pageSection: PageSection[data.pageSection]
    }, ((_data$listing$badges = data.listing.badges) === null || _data$listing$badges === void 0 ? void 0 : _data$listing$badges.refreshed) && {
      interactionCTA: 'promoted'
    }), {}, {
      brandingLevel: ((_data$listing$inclusi = data.listing.inclusions) === null || _data$listing$inclusi === void 0 ? void 0 : _data$listing$inclusi.brandingLevel) || 'NONE'
    }))), !isEmpty(data) && ga4.listingCardClickEvent(data));
  },
  'agency-click': (_key, data) => ga4.listingCardAgencyClickEvent(data),
  'featured-property-click': (_key, _ref2) => {
    var type = _ref2.type,
      position = _ref2.position,
      property = _ref2.property;
    return _objectSpread(_objectSpread(_objectSpread({}, mixpanel.clickListingCard({
      interactionCTA: type === 'featured-property' ? 'Featured Property' : 'Top Spot'
    })), ga.interaction(GAActions.FEATURE_PROPERTY, "".concat(GALabels.FEATURE_PROPERTY).concat(position))), ah.listingMetric(property.listing.id, analyticsMetric.FEATURED_PROPERTY_CLICK.metricKey));
  },
  '/display-appraisal-cta/': (_key, _ref3) => {
    var interactionCTA = _ref3.interactionCTA;
    return mixpanel.displayAppraisalCta({
      interactionCTA
    });
  },
  '/request-a-free-appraisal-click/': (_key, _ref4) => {
    var enquiryCTA = _ref4.enquiryCTA;
    return mixpanel.displayContactAgentForm({
      enquiryCTA
    });
  },
  '/call-reveal/': () => mixpanel.revealPhone({
    enquiryCTA: MixpanelLabels.SOLD_AGENCY_CARDS
  }),
  '/send-enquiry/': (_key, _ref5) => {
    var agentId = _ref5.agentId,
      agentName = _ref5.agentName,
      agencyId = _ref5.agencyId,
      agencyName = _ref5.agencyName;
    return mixpanel.emailEnquiry({
      agencyId,
      agency: agencyName,
      agentId,
      agentName
    });
  },
  'popup-window.add-to-watchlist-click': (_key, data) => ga4.listingCardAddToWatchlistEvent(data),
  'view-agents-click': (_key, _ref6) => {
    var elementText = _ref6.elementText;
    return ga4.viewRealEstateAgentsInClickEvent({
      elementText
    });
  },
  'suburb-link-click': (_key, _ref7) => {
    var position = _ref7.position,
      listingCategory = _ref7.listingCategory,
      elementText = _ref7.elementText,
      elementTitle = _ref7.elementTitle;
    return ga4.surroundingSuburbsClickEvent({
      position,
      listingCategory,
      elementText,
      elementTitle
    });
  },
  'show-no-results': () => mixpanel.displayNoProperties(),
  'show-similar-properties': () => mixpanel.displaySimilarProperties(),
  'similar-properties-loaded': (_key, _ref8) => {
    var initialQuery = _ref8.initialQuery,
      finalQuery = _ref8.finalQuery,
      serverDuration = _ref8.serverDuration,
      totalAttempts = _ref8.totalAttempts,
      clientDuration = _ref8.clientDuration,
      totalMatched = _ref8.totalMatched;
    return mixpanel.similarPropertiesLoaded({
      crossPromotion: {
        initialQuery,
        finalQuery,
        serverDuration,
        totalAttempts,
        clientDuration,
        totalMatched
      }
    });
  },
  'click-include-surrounding-areas': () => mixpanel.includeSurroundingAreas(),
  'create-property-alert': (_key, _ref9) => {
    var pageSection = _ref9.pageSection;
    return mixpanel.createPropertyAlert({
      pageSection: PageSection[pageSection]
    });
  }
};